import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
} from 'react-admin';
import AzureStorageTitle from './AzureStorageTitle';

const AzureStorageShow = props => (
    <Show title={<AzureStorageTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="account_name" />
            <TextField source="account_key" />
            <TextField source="container" emptyText="-" />
        </SimpleShowLayout>
    </Show>
);

export default AzureStorageShow;